import { fromEvent } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

export function hidden(dom: Document) {
  return fromEvent(dom, 'visibilitychange').pipe(
    map(ev => (ev.currentTarget as Document).hidden),
    startWith(dom.hidden),
  );
}
